import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { api, setPortalHeader } from "@/lib/api";
import { applyTheme } from "@/lib/theme";

const PortalContext = createContext(null);

export function PortalProvider({ children }) {
  const { portalKey } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    setError(null);
    setData(null);
    setPortalHeader(portalKey);
    api
      .get(`/portals/${portalKey}`)
      .then((res) => {
        setData(res.data);
        applyTheme(res.data.config?.theme);
      })
      .catch((e) => setError(e))
      .finally(() => setLoading(false));
  }, [portalKey]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <PortalContext.Provider
      value={{
        portalKey,
        loading,
        error,
        reload: load,
        portal: data?.portal,
        config: data?.config,
        categories: data?.categories || [],
        locations: data?.locations || [],
        theme: data?.config?.theme || {},
      }}
    >
      {children}
    </PortalContext.Provider>
  );
}

export const usePortal = () => useContext(PortalContext);
